/*
 *
 *  * Copyright (c) [hoarfroster-frontend] 2026. All Rights Reserved.
 *  *
 *  * Last Modified on May 22, 2026 by hoarfroster
 *
 */

import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import { Scaffold } from '@/scaffold';
import { initializeTheme } from '@utils/theme.ts';

(async () => {
    initializeTheme();

    const root = createRoot(document.getElementById('root')!);
    root.render(
        <StrictMode>
            <Scaffold />
        </StrictMode>
    );
})();
